import React, { useState, useEffect } from 'react';
import HeaderAdmin from './HeaderAdmin';
import editIcon from './edit.png';

function Header() {
    const [isAdmin] = useState(() => {
        const token = localStorage.getItem('token');
        return token && JSON.parse(atob(token.split('.')[1])).is_admin;
    });
    const [headers, setHeaders] = useState([]);
    const [editingIndex, setEditingIndex] = useState(-1);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        fetch(`${apiUrl}/api/headers`)
            .then(response => response.json())
            .then(data => setHeaders(data))
            .catch(error => console.error("Erro ao buscar headers:", error));
    }, [apiUrl]);

    const handleSave = (index) => {
        const token = localStorage.getItem('token');
        const header = headers[index];
        const updatedHeader = {
            title: header.title,
            button_text: header.button_text,
            button_href: header.button_href
        };

        fetch(`${apiUrl}/api/headers`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(updatedHeader)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Falha ao atualizar o cabeçalho');
                }
                return response.json();
            })
            .then(() => {
                const updatedHeaders = [...headers];
                updatedHeaders[index] = updatedHeader;
                setHeaders(updatedHeaders);
                setEditingIndex(-1);
            })
            .catch(error => console.error("Erro ao atualizar header:", error));
    };

    const handleEdit = (index) => {
        setEditingIndex(index);
    };

    return (
        <header className="bg-white text-black shadow-md">
            {isAdmin && <HeaderAdmin />}
            <div className="container mx-auto flex items-center justify-center py-4">
                <img src="/img/caq.png" alt="Logo" className="h-12 mr-4" />
                <h3 className='text-lg font-semibold'>Central de Atenção Questor</h3>
            </div>
            <div className="bg-primary p-4 text-white flex flex-wrap justify-around items-center">
                {headers.map((header, index) => (
                    <div key={header.id} className="p-2">
                        {editingIndex === index ? (
                            <div className="items-start space-y-2">
                                <input
                                    className="w-full text-lg font-semibold bg-blackColor p-2 rounded"
                                    value={header.title}
                                    onChange={(e) => {
                                        const newHeaders = [...headers];
                                        newHeaders[index].title = e.target.value;
                                        setHeaders(newHeaders);
                                    }}
                                />
                                <input
                                    className="w-full text-lg font-semibold bg-blackColor p-2 rounded"
                                    value={header.button_text}
                                    onChange={(e) => {
                                        const newHeaders = [...headers];
                                        newHeaders[index].button_text = e.target.value;
                                        setHeaders(newHeaders);
                                    }}
                                />
                                <input
                                    className="w-full text-lg font-semibold bg-blackColor p-2 rounded"
                                    value={header.button_href}
                                    onChange={(e) => {
                                        const newHeaders = [...headers];
                                        newHeaders[index].button_href = e.target.value;
                                        setHeaders(newHeaders);
                                    }}
                                />
                                <button
                                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                                    onClick={() => handleSave(index)}
                                >
                                    Salvar
                                </button>
                            </div>
                        ) : (
                            <div className="flex items-center space-x-12">
                                <p className='text-lg font-bold max-w-xl'>{header.title}</p>
                                <a
                                    href={header.button_href}
                                    className="bg-orangeColor text-white px-6 py-2 ml-4 font-semibold rounded hover:bg-darkOrange transition-colors"
                                >
                                    {header.button_text}
                                </a>
                                {isAdmin && (
                                    <button
                                        className="ml-4 text-lg  text-white"
                                        onClick={() => handleEdit(index)}
                                    >
                                        <img src={editIcon} alt='Editar' />
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </header>
    );
}

export default Header;
